/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { updateSettings } from '../../base/settings/actions';
import { getLocalJitsiVideoTrack } from "../../base/tracks/functions.any";
import Checkbox from "../../base/ui/components/web/Checkbox";
import { isLobbyEnabledOnJoin } from "../../base/settings/functions.any";
import { translate } from "../../base/i18n/functions";
import PrejoinAlwaysShowCheckboxTooltip from "./PrejoinAlwaysShowCheckboxTooltip";
const useStyles = makeStyles()(theme => {
    return {
        container: {
            gridArea: 'checkbox',
            alignSelf: 'center',
            justifySelf: 'flex-start',
            paddingLeft: '24px',
        },
        wrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '334px',
            padding: '12px 0',
            ' label': {
                padding: 0,
                alignItems: 'flex-start',
            }
        },
    };
});
const PrejoinAlwaysShowCheckbox = (props) => {
    const { classes } = useStyles();
    const { isLobbyEnabledOnJoin } = props;
    const onChange = () => {
        const newValue = !isLobbyEnabledOnJoin;
        props.updateSettings({
            isLobbyEnabledOnJoin: newValue,
        });
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.wrapper },
            React.createElement(Checkbox, { label: React.createElement(PrejoinAlwaysShowCheckboxTooltip, null), onChange: onChange, checked: isLobbyEnabledOnJoin }))));
};
function mapStateToProps(state) {
    return {
        videoTrack: getLocalJitsiVideoTrack(state),
        isLobbyEnabledOnJoin: isLobbyEnabledOnJoin(state) ?? true,
    };
}
const mapDispatchToProps = {
    updateSettings,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(PrejoinAlwaysShowCheckbox));
